export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14375.48047866.jpg";